import { rebrandEnabled } from "./brandingFlag";
import { sessionPreview } from "./sessionPreview";

// Provider self sign-up (VM-10039) stays hidden until launch. Preview it with
// ?signup_preview=true. It is built on the rebranded login page, so it also
// needs the rebrand on. Flip SIGNUP_LAUNCHED to launch it.
const SIGNUP_LAUNCHED = false;

const signupPreviewEnabled = sessionPreview("signup_preview", "signupPreview");

/** Whether the provider sign-up flow and its "Sign up" tab are shown. */
export const signupEnabled = (): boolean =>
  rebrandEnabled() && (SIGNUP_LAUNCHED || signupPreviewEnabled());
